import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/ContactSection/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/Hero/HeroSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/HowDoesItWork/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/ListOfCategories/HeroCategoryBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/ListOfCategories/SeeAllProductsButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/pages/homepage/Testimonials/TestimonialsClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/heading.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
